"use strict";
// Let's move all type conversions all in this file, so we at least can test it
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterUndefined = exports.notUndefined = exports.truthy = exports.assign = void 0;
exports.assign = function (target, source) {
    if (source !== undefined) {
        return source;
    }
    return target;
};
function truthy(value) {
    return value !== false;
}
exports.truthy = truthy;
function notUndefined(value) {
    return value !== undefined;
}
exports.notUndefined = notUndefined;
function filterUndefined(array) {
    return array.filter(notUndefined);
}
exports.filterUndefined = filterUndefined;
